// components/TawkMessenger.tsx
import { useEffect } from "react";

const TawkMessenger = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/6831f0e044b3cd190ef79fe5/1is1h9rj6";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);

    return () => {
      // Clean up script if needed
      const existingScript = document.querySelector(
        'script[src="https://embed.tawk.to/6831f0e044b3cd190ef79fe5/1is1h9rj6"]'
      );
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default TawkMessenger;
